import { useNavigate } from 'react-router-dom';
import { facilities } from '@/mocks/hotelData';

export default function FacilitySection() {
  const navigate = useNavigate();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs md:text-sm text-secondary-600 tracking-widest uppercase font-medium">
            World-Class Facilities
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-2 mb-3">
            酒店设施与服务
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            从水疗中心到恒温泳池，从健身中心到娱乐场，新葡京酒店为您提供全方位的奢华享受
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {facilities.map((facility) => (
            <button
              key={facility.id}
              onClick={() => navigate('/category/facilities')}
              className="group flex flex-col items-center text-center p-5 md:p-6 bg-background-100 rounded-xl border border-background-200/70 hover:border-secondary-400/40 hover:bg-background-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-3 md:mb-4 group-hover:bg-secondary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${facility.icon} text-xl md:text-2xl`}></i>
              </div>
              <h4 className="font-heading text-sm md:text-base font-semibold text-foreground-800 mb-1.5">{facility.name}</h4>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{facility.description}</p>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}